import { DeclareAndSubmitApplicationModel } from '../../api/models';
import { VisibilityFunctions } from '../types';

export const showDeclarantTitleOther = (values: DeclareAndSubmitApplicationModel) => {
    return values.isDeclarantSameAsPrimaryCompanyContact === 'No' && values.title === 'Other';
};

const showIfDeclarantNotTheSameAsPrimaryCompanyContact = (values: DeclareAndSubmitApplicationModel) => {
    return values.isDeclarantSameAsPrimaryCompanyContact === 'No';
};

const showIfDeclarantTheSameAsPrimaryCompanyContact = (values: DeclareAndSubmitApplicationModel) => {
    return values.isDeclarantSameAsPrimaryCompanyContact === 'Yes';
};

export const rndDeclaration: VisibilityFunctions<DeclareAndSubmitApplicationModel> = {
    title: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
    titleOther: showDeclarantTitleOther,
    firstName: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
    lastName: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
    position: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
    phone: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
    email: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
    entityDetails: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
    primaryCompanyContact: showIfDeclarantTheSameAsPrimaryCompanyContact,
    declarantRelationshipWithCompany: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
};
